const DEFAULT_PUBLIC_TRACKING_HOSTS = ['status.bwkin.ru'];

const normalizeHost = (value) => String(value || '').trim().toLowerCase();

export const getPublicTrackingHosts = () => {
  const configuredHosts = String(process.env.REACT_APP_PUBLIC_TRACKING_HOSTS || '')
    .split(',')
    .map(normalizeHost)
    .filter(Boolean);

  return configuredHosts.length ? configuredHosts : DEFAULT_PUBLIC_TRACKING_HOSTS;
};

export const isPublicTrackingHost = (hostname = window.location.hostname) => (
  getPublicTrackingHosts().includes(normalizeHost(hostname))
);

export const isLegacyPublicTrackingRoute = (locationLike = window.location) => {
  const pathname = String(locationLike?.pathname || '');
  const hash = String(locationLike?.hash || '');

  return (
    pathname === '/track-order'
    || pathname === '/track-order/'
    || hash.startsWith('#/track-order')
  );
};

export const isPublicTrackingEntryPoint = (locationLike = window.location) => (
  isPublicTrackingHost(locationLike?.hostname)
  || isLegacyPublicTrackingRoute(locationLike)
);
